import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    treeData;
    currVal;
    isDisabled;
    currIndex = '';
    defaultExpandKey = [];
    value = {};
    id = '';
    handleNodeClick(node) {
        console.log('node:', node);
        this.currIndex = node.id;
        this.value = { id: node.id, label: node.label };
        this.$emit('onUpdateName', { id: node.id, value: this.value.label }); // Sync not support
    }
    handleClick($event) {
        console.log('$event:', $event);
        if ($event) {
            const res = [];
            this.flattenTree(this.treeData, res);
            const isfind = res.filter(item => item.id.indexOf(this.value.id) >= 0);
            console.log('$event:', isfind);
            if (isfind.length > 0) {
                this.currIndex = isfind[0].id;
                this.$refs.tree.setCurrentKey(this.currIndex);
                this.defaultExpandKey.push(isfind[0].id);
            }
        }
    }
    flattenTree(data, flatted) {
        // TODO: move to common
        data.forEach((item) => {
            flatted.push({ id: item.id, label: item.label });
            if (item.children?.length > 0) {
                this.flattenTree(item.children, flatted);
            }
        });
    }
    mapOrgName(name) {
        const res = [];
        this.flattenTree(this.treeData, res);
        const isfind = res.find(item => item.id === name);
        this.value = isfind || {};
    }
    onOpenChange(newVal) {
        console.log('curr val:', newVal);
        this.mapOrgName(newVal);
    }
};
__decorate([
    Prop()
], default_1.prototype, "treeData", void 0);
__decorate([
    Prop()
], default_1.prototype, "currVal", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "isDisabled", void 0);
__decorate([
    Watch('currVal', { immediate: true })
], default_1.prototype, "onOpenChange", null);
default_1 = __decorate([
    Component({
        name: 'TreeSelect',
        i18n: {
            messages: {
                'en-us': {
                    organizationName: 'Organization Name',
                    code: 'Organization Code',
                    upDept: 'Upper Dept.',
                    organizationOwner: 'Organization Owner',
                    desc: 'Description',
                    submit: 'Submit',
                    cancel: 'Cancel',
                    create: 'Create',
                    ORGAEDIT: 'Edit',
                    ORGACREATE: 'Create',
                    ORGAROLE: 'Edit',
                },
                zh: {
                    organizationName: '组织名称',
                    code: '组织编码架构',
                    upDept: '上层组织架构',
                    organizationOwner: '组织owner',
                    desc: '描述',
                    submit: '提交',
                    cancel: '取消',
                    create: '新增组织',
                    ORGAEDIT: '编辑组织',
                    ORGACREATE: '新增组织',
                    ORGAROLE: '编辑角色',
                },
            },
        },
    })
], default_1);
export default default_1;
